const module = { name: 'shared/global/toastNotification', exports: {} }; const exports = module.exports;



import { swig as swig } from 'require-core';



const ToastType = {
    ERROR: 'error',
    INFO: 'info',
}


const LiveRegionAttributes = {
    ERROR: { role: 'alert', ariaLive: 'assertive' },
    INFO: { role: 'status', ariaLive: 'polite' },
}


const Constants = {
    AFTERBEGIN: 'afterbegin',
}


const Selectors = {
    BODY: 'body',
    TOAST_LINK: '.fd-toast-link',
    TOAST_LIVE_REGION: '#fd-toast-live-region',
}


let closeListenerController = null


let dismissTimeout = null


let toastNotification = null


let toastWrapper = null
function getLiveRegion() {
    return document.querySelector(Selectors.TOAST_LIVE_REGION);
}
function activateLiveRegion(type) {
    const liveRegion = getLiveRegion();
    if (!liveRegion) {
        return;
    }
    const attrs = type === ToastType.ERROR ? LiveRegionAttributes.ERROR : LiveRegionAttributes.INFO;
    liveRegion.setAttribute('role', attrs.role);
    liveRegion.setAttribute('aria-live', attrs.ariaLive);
}
function deactivateLiveRegion() {
    const liveRegion = getLiveRegion();
    if (!liveRegion) {
        return;
    }
    liveRegion.removeAttribute('role');
    liveRegion.removeAttribute('aria-live');
    liveRegion.innerHTML = '';
}
function cleanup() {
    clearTimeout(dismissTimeout);
    closeListenerController?.abort();
    deactivateLiveRegion();
    toastWrapper = null;
    toastNotification = null;
    dismissTimeout = null;
    closeListenerController = null;
}
function dismiss(animate) {
    if (animate) {
        toastNotification.classList.add('fd-toast-notification--exit');
        toastNotification.addEventListener('transitionend', () => {
            toastWrapper.remove();
            cleanup();
        }, { once: true });
    }
    else {
        toastWrapper?.remove();
        cleanup();
    }
}
function scheduleDismiss() {
    clearTimeout(dismissTimeout);
    dismissTimeout = setTimeout(() => {
        dismiss(true);
    }, 4000);
}
function cancelDismiss() {
    clearTimeout(dismissTimeout);
}
function init(type, opts) {
    dismiss(false);
    closeListenerController = new AbortController();
    const { title, message, link, selector, dismissSelectors } = opts;
    const elementRef = document.querySelector(selector ?? Selectors.BODY);
    if (elementRef) {
        activateLiveRegion(type);
        toastWrapper = document.createElement('div');
        toastWrapper.style.cssText = 'display: contents;';
        toastWrapper.innerHTML = swig.render('_toastNotification', {
            type,
            title,
            message,
            link,
        });
        const liveRegion = getLiveRegion();
        (liveRegion ?? elementRef).insertAdjacentElement(Constants.AFTERBEGIN, toastWrapper);
        toastNotification = document.getElementById('fd-toast-notification');
        requestAnimationFrame(() => {
            toastNotification.offsetHeight;
            toastNotification.classList.add('fd-toast-notification--visible');
        });
        registerCloseEvents(dismissSelectors);
    }
}
function registerCloseEvents(dismissSelectors) {
    scheduleDismiss();
    dismissSelectors?.forEach((closeElementRef) => {
        const elements = document.querySelectorAll(closeElementRef);
        elements?.forEach((element) => {
            element.addEventListener('click', () => dismiss(true), { signal: closeListenerController.signal });
        });
    });
    registerTouchEvents();
}
function registerTouchEvents() {
    let touchStartY = 0;
    toastNotification.addEventListener('touchstart', (e) => {
        touchStartY = e.touches[0].clientY;
        toastNotification.style.transition = 'none';
        cancelDismiss();
    });
    toastNotification.addEventListener('touchmove', (e) => {
        const deltaY = e.touches[0].clientY - touchStartY;
        if (deltaY < 0) {
            e.preventDefault();
            toastNotification.style.transform = `translateX(-50%) translateY(${deltaY}px)`;
        }
    }, { passive: false });
    toastNotification.addEventListener('touchend', (e) => {
        const deltaY = e.changedTouches[0].clientY - touchStartY;
        if (deltaY < -20) {
            cancelDismiss();
            toastNotification.classList.add('fd-toast-notification--swipe-dismiss');
            toastNotification.style.transition = '';
            toastNotification.style.transform = '';
            toastNotification.addEventListener('transitionend', () => {
                dismiss(false);
            }, { once: true });
        }
        else {
            toastNotification.style.transition = '';
            toastNotification.style.transform = '';
            scheduleDismiss();
        }
    });
}
function initError(opts) {
    init(ToastType.ERROR, opts);
}
function initInfo(opts) {
    init(ToastType.INFO, opts);
}
module.exports = {
    initError,
    initInfo,
};
export default module.exports;